<div class="d-flex flex-column align-items-center overflow-hidden">
    <button *adaptIfAuthorised="EditStrategicInputs; else featureNotEnabled"
            class="btn btn-primary"
            [adaptBlockingClick]="recordCompetitorsAnalysis">Record competitor analysis</button>
    <ng-template #featureNotEnabled>
        <span>This feature is enabled only for the Scale+ platform subscription.</span>
    </ng-template>
</div>
